import { tenantAwareApiWrapper, withOrchestratorClient } from './portal-http';
import { webPagesClient } from '@terra/shared-rest-clients-web-pages';
import type { WebPagesContract } from '@terra/shared-contracts-web-pages';
import type { WebPagesQueryDto } from '@terra/shared-contracts-web-pages';

export const portalWebpagesApi = {
  getWebPagesByApplication: (
    applicationId: string,
    options?: WebPagesQueryDto,
  ) =>
    tenantAwareApiWrapper<typeof WebPagesContract.getWebPages>({
      endpointFn: (headers) => {
        return webPagesClient.getWebPages({
          params: { applicationId },
          query: options,
          ...withOrchestratorClient(headers),
        });
      },
    }),

  getWebPageById: (webPageId: string) =>
    tenantAwareApiWrapper<typeof WebPagesContract.getWebPageById>({
      endpointFn: (headers) => {
        return webPagesClient.getWebPageById({
          params: { id: webPageId },
          ...withOrchestratorClient(headers),
        });
      },
    }),

  getWebPageFeatures: (webPageId: string) =>
    tenantAwareApiWrapper<typeof WebPagesContract.getWebPageFeatures>({
      endpointFn: (headers) =>
        webPagesClient.getWebPageFeatures({
          params: { id: webPageId },
          ...withOrchestratorClient(headers),
        }),
    }),

  getFeatureRelatedRequests: ({
    webpageId,
    featureId,
    skip,
    limit,
  }: {
    webpageId: string;
    featureId: string;
    skip?: number;
    limit?: number;
  }) =>
    tenantAwareApiWrapper<typeof WebPagesContract.getFeatureRelatedRequests>({
      endpointFn: (headers) =>
        webPagesClient.getFeatureRelatedRequests({
          params: { id: webpageId, featureId },
          query: { skip, limit },
          ...withOrchestratorClient(headers),
        }),
    }),

  deleteWebPage: (webPageId: string) =>
    tenantAwareApiWrapper<typeof WebPagesContract.deleteWebPage>({
      endpointFn: (headers) =>
        webPagesClient.deleteWebPage({
          params: { id: webPageId },
          ...withOrchestratorClient(headers),
        }),
    }),

  triggerUpdateWebpages: (
    applicationId: string,
    credentialId: string | null,
    recreateAll?: boolean,
  ) =>
    tenantAwareApiWrapper<typeof WebPagesContract.triggerUpdateWebpages>({
      endpointFn: (headers) =>
        webPagesClient.triggerUpdateWebpages({
          body: {
            applicationId,
            credentialId,
            recreateAll,
          },
          ...withOrchestratorClient(headers),
        }),
    }),

  countUntrackedPages: (applicationId: string, credentialId: string | null) =>
    tenantAwareApiWrapper<typeof WebPagesContract.countUntrackedPages>({
      endpointFn: (headers) =>
        webPagesClient.countUntrackedPages({
          body: {
            applicationId,
            credentialId,
          },
          ...withOrchestratorClient(headers),
        }),
    }),

  countTotalPages: (applicationId: string, credentialId: string | null) =>
    tenantAwareApiWrapper<typeof WebPagesContract.countTotalPages>({
      endpointFn: (headers) =>
        webPagesClient.countTotalPages({
          body: {
            applicationId,
            credentialId,
          },
          ...withOrchestratorClient(headers),
        }),
    }),

  replaceWebpageScreenshot: (webPageId: string, screenshot: File) =>
    tenantAwareApiWrapper<typeof WebPagesContract.replaceWebpageScreenshot>({
      endpointFn: (headers) =>
        webPagesClient.replaceWebpageScreenshot({
          params: { id: webPageId },
          body: { screenshot },
          ...withOrchestratorClient(headers),
        }),
    }),
};
